/* eslint-disable no-open-modules-imports */
import type { FeatureGroup } from 'feature/feature-helpers';

export const articleQuestionsFeatures: FeatureGroup[] = [];

export const articleQuestionsDefaultConfig = {
    upvotequestion: true,
    questionteaser: true,
};
